import React from 'react';
import { useStyleConfig, vui } from '../core';
import Icon from '../icon';
import P from '../p';
import { cs } from '../utils';
import { inputColors } from './consts';
import { useInputContext } from './context';
/** Displaying help text bellow an input.. */
export const HelpText = vui((props, ref) => {
    const { className, children, isError, ...rest } = props;
    const inputProps = useInputContext();
    const mergedProps = { ...inputProps, ...props };
    const styles = useStyleConfig('Input', mergedProps);
    const color = isError ? inputColors.error : inputColors.helpText;
    return (React.createElement(P, { className: cs('vui-inputHelpText', className), color: color, display: "flex", py: 1, ref: ref, ...styles.helpText, ...rest },
        isError && React.createElement(Icon, { mr: 1, name: "falExclamationTriangle", pathFill: inputColors.error, size: "sm" }),
        children));
});
export default HelpText;
